import { Dialog, Button } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Content, ContentText } from "./styles";
import DialogActions from "../../../DialogActions/DialogActions";
import DialogTitle from "../../../DialogTitle/DialogTitle";
interface Props {
  handleRemove: () => void;
  children?: React.ReactNode;
}

const ConfirmationRemoveItemDialog = ({ handleRemove, children }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.confirmation_remove_item_dialog"; // tRP - translation root path

  const [open, setOpen] = useState(false);

  const handleRemoveItem = () => {
    handleRemove();
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div onClick={() => setOpen(true)}>{children}</div>
      {/* <ActionButton color="secondary" onClick={() => setOpen(true)}>
        <FontAwesomeIcon icon={faTimes} />
      </ActionButton> */}
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle
          title={t(`${tRP}.title`)}
          handleClose={handleClose}
        />
        <Content>
          <ContentText>{`${t(`${tRP}.message`)}`}</ContentText>
        </Content>
        <DialogActions
          handleCancel={handleClose}
          useGoback
        >
          <Button
            onClick={handleRemoveItem}
            variant="contained"
            color="error"
          >
            {`${t(`${tRP}.remove`)}`}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmationRemoveItemDialog;
